import { styled } from "@mui/material";
import { Topic } from "api/types";
import { Topics } from "./topics";
import { TopicTag } from "./TopicTag";

const PREFIX = "TopicTagList";

const classes = {
	chip: `${PREFIX}-chip`,
};

const Root = styled("div")(({ theme }) => ({
	[`& .${classes.chip}`]: {
		marginRight: theme.spacing(1),
		marginBottom: theme.spacing(1),
		padding: theme.spacing(1),
		backgroundColor: theme.palette.grey[200],
	},
}));

export interface TopicTagListProps {
	selected: Topic[];
	handler: (realms: Topic[]) => void;
}

export const TopicTagList = (props: TopicTagListProps): JSX.Element => {
	const { selected, handler } = props;

	const handleClick = (selectedTag: Topic): void => {
		selected.includes(selectedTag)
			? handler(selected.filter((tag) => tag !== selectedTag))
			: handler([...selected, selectedTag]);
	};

	const handleDelete = (selectedTag: Topic): void => {
		if (selected.includes(selectedTag)) {
			handler(selected.filter((tag) => tag !== selectedTag));
		}
	};

	return (
		<Root>
			{Topics.map((topic) => (
				<TopicTag
					key={topic.name}
					selected={selected.includes(topic.name)}
					name={topic.name}
					onClick={handleClick}
					onDelete={handleDelete}
				/>
			))}
		</Root>
	);
};
